<template lang='pug'>
DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider')
  div(slot-scope='{ data: response, error, loading }')
    DataTable(
      v-if='response && response.data'
      :data='response && response.data'
      ref='dataTable'
      :title="$t('messagesNotUnderstood.searchResult')",
      :customTotal='(response && response.total) || 0'
      @pagination='handlePagination'
      @click-row='openDialog',
      :currentSort.sync='filter.orderBy',
      :currentSortOrder.sync='filter.order',
      :selectable='false'
      :loading='loading'
      customHeader
      :endpoint='endpoint'
      :filter='filter'
      :labels='labels'
      :formatLabelFunction='formatLabels'
      :createHeader='createHeaderPDF'
      @search-options='searchOptions'
      @search-query='handleSearch'
      )
      template(slot='footer' slot-scope='{ pagination }')
        v-row(style='justify-content: flex-end;')
          v-col(cols='auto')
            md-field
              label(for='pages') {{ $t('assistantsList.perPage') }}
              md-select(v-model='pagination.perPage' name='pages' )
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item')
                  | {{ item }}
      template(slot='cells' slot-scope='{ item }')
        md-table-cell(:md-label='labels[0]' md-sort-by='request_datetime') {{ formatLabels(item, 0) }}
        md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
        md-table-cell(:md-label='labels[4]' style='display: table-cell;' v-html='formatLabels(item, 4)')
        md-table-cell(:md-label='labels[2]' style='display: table-cell;' v-html='formatLabels(item, 2)' :value="(item)")
        md-table-cell(:md-label='labels[3]' style='display: table-cell;' v-html='formatLabels(item, 3)')
    v-dialog(v-model='dialog' max-width='700px' scrollable persistent)
      ChatConversation(
        :chatLoader='chatLoader'
        :chatData='chatData'
        :chatInfo='chatInfo'
        :channelConfig='channelConfig'
        :key='chatInfo._id'
        @close='closeDialog'
      )
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import DateIntervalComponent from '@/components/DateInterval.vue'
import DataTable from '@/components/SearchMessagesNotUnderstood/Table.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'
import mock from '@/components/SearchMessagesNotUnderstood/mock'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  props: {
    wordcloud: {
      type: String,
      defalut: ''
    }
  },
  components: {
    Pagination,
    DateIntervalComponent,
    DataTable,
    DataProvider,
    ChatConversation
  },
  watch: {
    wordcloud: {
      handler (value) {
        this.handleSearch(value)
      }
    },
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  data () {
    return {
      search: null,
      labels: [
        this.$t('search.start'),
        this.$t('search.sentBy'),
        this.$t('search.input'),
        this.$t('search.message'),
        this.$t('search.cpfCitizen')],
      response: {
        data: mock,
        total: 4
      },
      dialog: false,
      chatLoader: false,
      showFilter: true,
      filter: {
        order: 'desc',
        orderBy: 'request_datetime',
        page: 0,
        perPage: null,
        by: null,
        search: null
      },
      tableData: chatsList,
      searchedData: [],
      chatData: {},
      chatInfo: {},
      channelConfig: null
    }
  },
  computed: {
    ...mapFields('chatHistoryFilter', ['sender_name']),
    ...mapFields('reports', ['dateInterval']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    ...mapFields('selectedAssistant', ['assistantId']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/reports/notUnderstandInformationList`
    },
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  methods: {
    cpfMasked (cpfValue) {
      let cpfFormatted = cpfValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
      return cpfFormatted
    },
    /* ---------------------
      Remoção de Acentuação
    ------------------------ */
    removeAccentWord (word) {
      let wordFormatted = word.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return wordFormatted
    },

    /* ---------------------------------
      Filtro botão select input-entrada
    ------------------------------------ */
    /* mappingOptions (value) {
      const result = []
      value.split(',').map((item) => {
        switch (item) {
          case 'All':
          case 'Todos':
            result.push('all')
            break
          case 'Botón':
          case 'Button':
          case 'Botão':
            result.push('button')
            break
          case 'Texto libre':
          case 'Free Text':
          case 'Texto Livre':
            result.push('text')
            break
          default:
            break
        }
      })
      return result.toString()
    }, */
    /* searchOptions (nV) {
      if (nV?.length > 0) {
        this.$set(this.filter, 'opt', this.mappingOptions(nV.toString()))
      } else {
        this.$delete(this.filter, 'opt')
      }
    }, */

    /* -------
      Filtro
    ---------- */
    handleSearch (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', this.removeAccentWord(searchText))
      } else {
        this.$delete(this.filter, 'search')
      }
    },
    changeFilters () {
      this.filter.service_code = this.protocol
      this.filter.user_name = this.user_name
      this.filter.user_id = this.cpf
      this.filter.user_contact = this.phone
      this.filter.bot = this.bot
      this.filter.channel = this.channelFilter
      this.filter.evaluation = this.evaluationFilter
      this.filter.intent = this.intentFilter
      this.$refs.dataProvider.load()
    },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },

    /* -----------
      Pagination
    -------------- */
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },

    /* -------------------
      Card infor por row
    ---------------------- */
    async openDialog (rowProps) {
      // eslint-disable-next-line camelcase
      const conversationId = rowProps.item?.conversation_id
      this.dialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions'
          }
        })
        this.chatData = result.data
        this.chatInfo = result.data.parent ? result.data.parent : {} // rowProps.item
      } catch (error) {
      }
      this.chatLoader = false
    },
    closeDialog () {
      this.dialog = false
    },

    /* --------------------
      Formato data e hora
    ----------------------- */
    updatedDate () {
      const from = this.dateInterval.timestamp1
      this.filter.from = moment(from).utcOffset(0, true).format('YYYY-MM-DD[T]HH:mm:ss')
      const to = this.dateInterval.timestamp2
      this.filter.to = moment(to).utcOffset(0, true).format('YYYY-MM-DD[T]HH:mm:ss')
      this.$refs.dataProvider.load()
    },
    formatDate (item, type) {
      let date = item[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    checkIfFormatDuration (item) {
      return item.total_duration ? this.fomartDuration(item.total_duration) : '-'
    },
    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },

    /* -------------------------
      Labels e infos da tabela
    ---------------------------- */
    formatLabels (item, i) {
      // eslint-disable-next-line camelcase
      switch (i) {
        case 0:
          return this.formatDate(item, 'request_datetime')
        case 1:
          return item?.sender_name_of_input_text ? item.sender_name_of_input_text : '-'
        case 2:
          if (item.isButtonChoice) return 'Botão'
          return 'Texto Livre'
        case 3:
          return item.input_text
        case 4:
          return this.cpfMasked(item.user_id)

        default:
          break
      }
    },

    /* ----------------
      PDFs e arquivos
    ------------------- */
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('search.messagesNotUnderstood'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('search.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).format('DD/MM/YYYY H:mm:ss')
      let formattedDate2 = moment(this.filter.to).format('DD/MM/YYYY H:mm:ss')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('search.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    const from = this.dateInterval.timestamp1
    this.filter.from = moment(from).utcOffset(0, true).format('YYYY-MM-DD[T]HH:mm:ss')
    const to = this.dateInterval.timestamp2
    this.filter.to = moment(to).utcOffset(0, true).format('YYYY-MM-DD[T]HH:mm:ss')
  }
}
</script>

<style lang='css'>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
</style>
